import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftTeamsAutoAttendant } from '../../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class TeamsAutoAttendantsResource {
  private _httpClient = inject(HttpClient);

  getAllAutoAttendants(tenantId: string): Observable<MicrosoftTeamsAutoAttendant[]> {
    return this._httpClient.get<MicrosoftTeamsAutoAttendant[]>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/auto-attendants`,
    );
  }

  updateAutoAttendant(
    tenantId: string,
    autoAttendantId: string,
    autoAttendant: MicrosoftTeamsAutoAttendant,
  ): Observable<void> {
    return this._httpClient.put<void>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/auto-attendants/${autoAttendantId}`,
      autoAttendant,
    );
  }

  createAutoAttendant(tenantId: string, autoAttendant: MicrosoftTeamsAutoAttendant): Observable<void> {
    return this._httpClient.post<void>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/auto-attendants`,
      autoAttendant,
    );
  }

  deleteAutoAttendant(tenantId: string, autoAttendantId: string): Observable<void> {
    return this._httpClient.delete<void>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/auto-attendants/${autoAttendantId}`,
    );
  }
}
